import { render, staticRenderFns } from "./GoodsDialog.vue?vue&type=template&id=4b5acf6c&scoped=true&"
import script from "./GoodsDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDialog.vue?vue&type=style&index=0&id=4b5acf6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5acf6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5acf6c')) {
      api.createRecord('4b5acf6c', component.options)
    } else {
      api.reload('4b5acf6c', component.options)
    }
    module.hot.accept("./GoodsDialog.vue?vue&type=template&id=4b5acf6c&scoped=true&", function () {
      api.rerender('4b5acf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pallet/components/GoodsDialog.vue"
export default component.exports